export interface CaseFeature{
  id?:number
  code:string | null,
  name:string | null,
  caseTypes:any[],
  icon?:string| null,
  type:CaseFeatureTypeEnum | null,
  listOptions?:string[],
  orderNo:number | null,
  isActive:boolean,
}


export enum CaseFeatureTypeEnum{
  Text="Text",
  Date="Date",
  SingleSelect="SingleSelect",
  MultiSelect="MultiSelect",
  Boolean="Boolean"
}


export interface CaseFeatureFilters {
  search?: string | null;
  caseTypes?: number[] | null;
  type?: string | null;
  isActive?: boolean | null;
}
